import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isEmpty,isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    const [Status, setStatus] = React.useState(props.Status);
    const currencies = [
        {
            value: 0,
            show:true,
            label:<IntlMessages id="input.Event.Status.option1" />,
        },
        {
            value: 1,
            show:true,
            label:<IntlMessages id="input.Event.Status.option2" />,
        },
        {
            value: 3,           
            show:false,
            label: <IntlMessages id="input.Event.Status.option4" />,
        }, //show:isUndefined(props.isFrom)?false:parseInt(props.isFrom)===1,
    ];
    const handleChange = (event) => {
        setStatus(event.target.value);
        props.onchangeHanelEvent("Status",event.target.value)
    };

    // style={{ height: '64px', paddingTop: '15px' }}
    React.useEffect(()=>{
        let Label =parseInt(props.Status)===3?0:parseInt(props.Status) 
        if(parseInt(props.Status) === 3){
            //
            if(isEmpty(props.EventStatusList)){
                Label = 0
            }else{
                if(isEmpty(props.EventStatusList.filter(item=>parseInt(item.Value) === 3))){
                    Label = 0
                }else{ Label = 3}
            }
            //
        }
        setStatus(Label)
    },[props.Status])
    return (
        <form className={classes.root}>
            <div>
                <TextField
                    label={<IntlMessages id="appKontoModule.status"/>}
                    select
                    disabled={parseInt(Status)===2?true:isUndefined(props.disAbeld)?false:props.disAbeld}
                    variant="outlined"
                    size="small"
                    value={Status}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {
                        parseInt(Status) === 2?
                        <option key={2} value={2}><IntlMessages id="input.Event.Status.option3"/></option>
                        :
                        isEmpty(props.EventStatusList)?
                        currencies.map((option) => 
                        {
                            if(option.show === true){
                                return (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                    )
                            }
                        })
                        :
                            props.EventStatusList.filter(item=>{return parseInt(item.Value) !== 2})
                            .map(item=>{
                             return (
                                 <option key={item.Value} value={item.Value}>
                                 {item.Meta}
                             </option>
                             )
                            })                        
                    }
                </TextField>
            </div>
        </form>
    );
}